import { AdditionalItem } from "./AdditionalItem";
import css from "./styles.module.scss";
import { MobileAdditionalsView } from "./MobileAdditionalsView";
export const AdditionalsView = ({ additionals }) => {
  const isMobile = window.matchMedia("(max-width: 1060px)").matches;
  if (isMobile) {
    return <MobileAdditionalsView additionals={additionals} />;
  }

  return (
    <div className={css.AdditonalsView}>
      <AdditionalItem additional={additionals[0]} />
      <AdditionalItem additional={additionals[1]} />
      <AdditionalItem additional={additionals[2]} />
      <AdditionalItem
        additional={additionals[3]}
        className={css.firstAbsoluteAdditional}
      />
      <AdditionalItem
        additional={additionals[4]}
        className={css.secondAbsoluteAdditional}
      />
    </div>
  );
};
